export const Constants = {
  TAG_NAME: 'pop-disclosure-component',
  DATA_COLLAPSIBLE_BUTTON_TEXT: 'data-collapsible-button-text',
  DATA_EXPANDED: 'data-expanded',
} as const;
